<template>
  <div class="concert">
    <div v-if="isLoaded && tableData && tableData.length" class="concert-content">
      <CSSTitleLink :title-text="muzikConcertTitle" :title-link="muzikConcertURL" />
      <div class="mk-table mk-table-concert-list">
        <div class="table-th table-tr">
          <div class="table-td td_40">
            {{ $t('CONCERT.PERFORMANCE_TITLE') }}
          </div>
          <div class="table-td td_20">
            {{ $t('CONCERT.PERFORMANCE_TIME') }}
          </div>
          <div class="table-td td_40">
            {{ $t('CONCERT.PERFORMANCE_VENUE') }}
          </div>
        </div>
        <a
          v-for="(event, index) in tableData" :key="index+'_'+event.id"
          class="table-tr"
          :href="eventHref(event)" target="_blank" rel="noopener noreferrer"
        >
          <div class="table-td title">
            {{ event.title }}
          </div>
          <div class="table-td date">
            {{ event.venue && event.venue.datetime }}
            <!-- <div v-for="(datetime, index) in event.datetime" :key="index" class="item">
              {{ timeConverter(datetime) }}
              <span v-if="$i18n.localePath() === 'tw' && index !== (event.venue.length - 1)">
                、
              </span>
              <span v-else-if="index !== (event.venue.length - 1)">
                ,
              </span>
            </div> -->
          </div>
          <div class="table-td location">
            {{ event.venue && event.venue.name }}
            <!-- <div v-for="(venue, index) in event.venue" :key="index" class="item">
              {{ venue.venue_name }}
              <span v-if="$i18n.localePath() === 'tw' && index !== (event.venue.length - 1)">
                、
              </span>
              <span v-else-if="index !== (event.venue.length - 1)">
                ,
              </span>
            </div> -->
          </div>
        </a>
      </div>
    </div>
    <div v-else-if="isLoaded" class="concert-content">
      <!-- <NotResultDummy :message="$t('DUMMY.NOT_RESULT')" /> -->
    </div>
    <div v-else class="container--loader">
      <Loader :loading="!isLoaded" />
    </div>
    <div v-if="isLoaded && tableData && tableData.length" class="pgnnp-container">
      <Paganiniplus />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
// import NotResultDummy from '@/components/common/DummyStatus/NotResultDummy'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import CSSTitleLink from '@/components/css-web/CSSTitleLink'
import EventService from '../../assets/services/EventService'

export default {
  name: 'AIREventTable',
  components: {
    Loader,
    // NotResultDummy,
    Paganiniplus,
    CSSTitleLink
  },
  data() {
    return {
      tableData: [],
      isLoaded: false
    }
  },
  computed: {
    muzikConcertURL() {
      return `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    muzikConcertTitle() {
      return this.$i18n.t('AIR.CONCERT_HEADLINE')
    }
  },
  created() {},
  mounted() {
    this.getEvents('', 1, 5)
  },
  methods: {
    async getEvents(query, page, perPage) {
      this.isLoaded = false
      let res = await EventService.getEventList(query, page, perPage, 'list')
      if (res && res.data) {
        this.tableData = res.data
      } else {
        this.tableData = null
      }
      this.isLoaded = true
    },
    eventHref(event) {
      return event && event.id
        ? `https://${process.env.VUE_APP_MUZIK_CONCERT}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/events/${event.id}`
        : `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    timeConverter(unixTimestamp) {
      let date = new Date(unixTimestamp * 1000)
      let year = date.getFullYear()
      let month = ('0' + (date.getMonth() + 1)).substr(-2)
      let day = ('0' + date.getDate()).substr(-2)
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/table.scss';

.concert:after{
  content: "";
  display: block;
  clear: both;
}
.concert-content {
  display: block;
  .mk-table {
    margin-bottom: 0px;
  }
  .mk-table .table-tr .table-td {
    vertical-align: middle;
  }
  > .title {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.63;
    color: $grey-50;
    margin: 0 0 24px;
  }
  .item {
    display: inline-block;
  }
}
.container--loader {
  display: block;
  min-height: 200px;
  margin: 66px auto 24px;
  text-align: center;
}

.pgnnp-container {
  display: block;
  margin: 36px auto;
}

@media only screen and (max-width: 1439.98px) {
  .concert-content {
    width: 100%;
    padding-right: 0;
    .mk-table{
      margin-bottom: 0;
    }
  }
  .pgnnp-container{
    width: 100%;
    float: unset;
    padding-top: 0;
    margin: 36px auto;
  }
}

@media only screen and (max-width: 1023.98px) {
  .concert-content {
    > .title {
      font-size: 20px;
      margin-bottom: 16px;
    }
  }
}

@media only screen and (max-width: 767.98px) {}
@media only screen and (max-width: 368.98px) {
  .pgnnp-container{
    margin: 36px -24px;
  }
}
</style>
